import { ROUTE_TAB_NAMES } from '~constants/common';

export const useIsCasinoWebsite = () => {
  const [, path] = window.location.pathname.split('/');

  return path === ROUTE_TAB_NAMES.GAMES;
};
